import React from 'react';
import { Row, Col, Badge } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import toastr from 'toastr';
import Spinner from 'react-spinkit';
import * as request from '../../utils/request';
import AdministratorStatusBoxes from './AdministratorStatusBoxes';
import * as runActions from '../../actions/runsActionCreators';
import RunForm from './RunForm';
import delay from 'lodash/delay';
import SelectAssignmentForm from './SelectAssignmentForm';
import moment from 'moment';
import label from '../../utils/lngEn';

class AddDropPeriodComponent extends React.Component {
  state = {
    isDownloading: false,
    isProcessingWaitlist: false
  };

  componentDidMount() {
    const processingWaitlistStatusUrl = localStorage.getItem('processingWaitlistStatusUrl');
    if (processingWaitlistStatusUrl) {
      this.setState({ isProcessingWaitlist: true });
      this.checkProcessWaitlistStatus(processingWaitlistStatusUrl);
    }
    
    // Get finished computations if needed
    this.props.runActions.getFinishedComputations();
  }
  
  // Methods for completed assignments section
  handleDownloadComputation = type => () => {
    const { currentComputationId } = this.props;
    const activeId = currentComputationId && currentComputationId.value ? currentComputationId.value : currentComputationId;
    
    this.setState({ isDownloading: true });
    this.props.runActions
      .makeOutput(activeId, type)
      .then(url => {
        window.location.href = url;
        this.setState({ isDownloading: false });
      })
      .catch(() => {
        toastr.error('Download Error');
        this.setState({ isDownloading: false });
      });
  };
  
  handleAssignmentSummary = () => () => {
    const { currentComputationId } = this.props;
    const activeId = currentComputationId && currentComputationId.value ? currentComputationId.value : currentComputationId;
    
    this.setState({ isDownloading: true });
    this.props.runActions
      .getAllocations(activeId)
      .then(() => {
        const runName = localStorage.getItem('run');
        window.location.href = `/administer/${runName}/assignment/dashboard/${activeId}`;
      })
      .catch(err => {
        console.log('Error', err);
        this.setState({ isDownloading: false });
      });
  };
  
  parseAssignmentsOptions = (assignmentIds) => {
    if (!assignmentIds || !Array.isArray(assignmentIds)) return [];
    
    return assignmentIds.map(item => {
      if (!item || !item.id) return null;
      return {
        option: `Computation ${item.id} - ${moment(item.created_at).format('ll')}`,
        value: item.id
      };
    }).filter(Boolean);
  }

  checkPublishingStatus = url => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('GET', url)
        .then(response => {
          if (response.data.status === 'success') {
            return resolve(response.data.output);
          } else {
            delay(() => {
              resolve(this.checkPublishingStatus(url));
            }, 1000)
          }
        })
        .catch(() => {
          toastr.error('Error while publishing');
          return reject('Error');
        });
    });
    return promise;
  };

  componentDidMount() {
    const { run } = this.props;
    let progress = ((run.students_with_pending_requests * 100) / run.students).toFixed(1);
    if (!isNaN(progress)) {
      this.setState({ progress: progress });
    }
  }

  handleDownloadAssignment = () => {
    this.setState({ isDownloading: true });
    this.props.runActions
      .handleDownloadAssignment()
      .then(async data => {
        const finalOutput = await this.checkPublishingStatus(data.url);
        console.log(finalOutput);
        window.location.href = finalOutput;
        this.setState({ isDownloading: false });
      })
      .catch(() => console.log('Error'));
  };

  alterAddDrop = status => () => {
    this.props.runActions.alterAddDrop(status);
  };

  checkProcessWaitlistStatus = url => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('GET', url)
        .then(response => {
          if (response.data.status === 'success') {
            localStorage.setItem('processingWaitlistStatusUrl', '');
            window.location.reload();
            return resolve(response.data.output);
          } else {
            delay(() => {
              resolve(this.checkProcessWaitlistStatus(url));
            }, 1000);
          }
        })
        .catch(error => {
          console.log(error);
          toastr.error('Error while publishing ');
          return reject('Error');
        });
    });
    return promise;
  };

  processWaitlist = () => {
    this.setState({ isProcessingWaitlist: true });
    this.props.runActions
      .processWaitlist()
      .then(async output => {
        if (output.status === 'pending') {
          localStorage.setItem('processingWaitlistStatusUrl', output.url);
          await this.checkProcessWaitlistStatus(output.url);
        }
      })
      .catch(error => console.log(error));
  };

  handleRunFormSubmit = (values) => {
    this.setState({ submittingRunFormProgress: true });
    let data = {
      longname: values.longname,
      primary_contact: values.primary_contact,
      additional_find_classes_add_drop: values.additional_find_classes_add_drop,
      additional_manage_waitlist: values.additional_manage_waitlist,
      additional_manage_schedule: values.additional_manage_schedule,
      add_drop_not_open_text: values.add_drop_not_open_text
    };
    this.props.runActions.updateRun(data).then(() => {
      this.setState({ submittingRunFormProgress: false });
    });
  }

  updateRunJustAddDrop = (addDropVisibleToStudents) => {
    this.setState({ submittingRunFormProgress: true });

    this.props.runActions.updateRun({
      slug: this.props.run.slug,
      longname: this.props.run.longname,
      primary_contact: this.props.run.primary_contact,
      allow_students_min_change: this.props.run.allow_students_min_change,
      allow_students_max_change: this.props.run.allow_students_max_change,
      send_student_emails: this.props.run.send_student_emails,
      additional_student_text: this.props.run.additional_student_text,
      additional_find_classes_add_drop: this.props.run.additional_find_classes_add_drop,
      additional_manage_waitlist: this.props.run.additional_manage_waitlist,
      additional_manage_schedule: this.props.run.additional_manage_schedule,
      add_drop_not_open_text: this.props.run.add_drop_not_open_text,
      add_drop_visible_to_students: addDropVisibleToStudents
    }).then(() => {
      this.setState({ submittingRunFormProgress: false });
    });
  }

  render() {
    const { isDownloading, isProcessingWaitlist } = this.state;
    const { AssignmentPeriodRestriction, AssignmentPeriodRestrictionModals } = this.props;
    const { pending_requests, students, students_with_pending_requests } = this.props.run;

    // Debug state in AddDropPeriodComponent
    console.log('DEBUG - AddDropPeriodComponent state:', {
      isDownloading,
      isProcessingWaitlist,
      run: this.props.run
    });

    const downloadAssignmentBox = (
      <div className={'notification-primary mt-3'}>
        <h2>Download Current Assignment</h2>
        <p>To ensure fullest enrollments, close the add/drop session and process wait lists before downloading.</p>
        <button className="btn btn-primary" onClick={this.handleDownloadAssignment}>
          Download Dataset
        </button>
      </div>
    );

    return (
      <Row>
        <Col md={8}>
          <div className="page-subtitle">
            <Row>
              <Col md={10}>
                <span className="sub-title-gray mr-2">{'Add/Drop Period'}</span>
                {this.props.run.slug}
              </Col>
             <Col md={2} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                <div>
                  <Badge style={{color: 'white', backgroundColor: 'red'}}> {this.props.run.send_student_emails ? 'EMAIL ACTIVE' : 'EMAIL NOT ACTIVE'} </Badge>
                </div>
              </Col>
            </Row>
           
            
          </div>
          <AdministratorStatusBoxes
            {...this.props}
            alterAddDrop={this.alterAddDrop}
            processWaitlist={this.processWaitlist}
            isProcessingWaitlist={isProcessingWaitlist}
            updateRunJustAddDrop={this.updateRunJustAddDrop}
          />
          {console.log('DEBUG - Download box rendering condition:', {
            isDownloading,
            'Will show download box': !isDownloading
          })}
          {isDownloading ? (
            <div className="spinner-box">
              <h3 className="text-center mb-3">Downloading assignment...</h3> <Spinner spinnerName="three-bounce" />
            </div>
          ) : (
            <div>
              {/* Completed Assignments are Available section */}
              <div className={'notification-primary mt-3'}>
                <h2>{label.completedAssignmentHeader}</h2>
                <p>{label.completedAssignmentMessage}</p>
                <div>
                  {(() => {
                    const computations = this.parseAssignmentsOptions(this.props.run.finishedComputations).reverse();
                    const computationId = computations[0] ? computations[0].value : 0;
                    const assignmentFormInitialValues = { computationId: computationId };
                    
                    return computationId ? (
                      <SelectAssignmentForm
                        computations={computations}
                        handleDownloadComputation={this.handleDownloadComputation}
                        handleAssignmentSummary={this.handleAssignmentSummary}
                        initialValues={assignmentFormInitialValues}
                      />
                    ) : null;
                  })()}
                </div>
              </div>
              
              {/* Original Download Current Assignment box */}
              {downloadAssignmentBox}
            </div>
          )}
          <div>
            {this.props.run.id ? (
              <RunForm
                onSubmit={this.handleRunFormSubmit}
                initialValues={{
                  slug: this.props.run.slug,
                  longname: this.props.run.longname,
                  primary_contact: this.props.run.primary_contact,
                  allow_students_min_change: this.props.run.allow_students_min_change,
                  allow_students_max_change: this.props.run.allow_students_max_change,
                  send_student_emails: this.props.run.send_student_emails,
                  additional_student_text: this.props.run.additional_student_text,
                  additional_find_classes_add_drop: this.props.run.additional_find_classes_add_drop,
                  additional_manage_waitlist: this.props.run.additional_manage_waitlist,
                  additional_manage_schedule: this.props.run.additional_manage_schedule,
                  add_drop_not_open_text: this.props.run.add_drop_not_open_text
                }}
                progress={this.state.submittingRunFormProgress}
              />
            ) : null}
          </div>
          {AssignmentPeriodRestriction}
          {AssignmentPeriodRestrictionModals}
        </Col>
        <Col md={4}>
          <div className="sidebar-container">
            <div className="sidebar-header">Add/Drop Session Status</div>
            <div className="progress-box mt-4">
              {pending_requests}
              {pending_requests === 1 ? ' pending request' : ' pending requests'}
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow="70"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: this.state.progress + '%' }}
                />
              </div>
              <p>
                From {students_with_pending_requests} of {students} students.
              </p>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  const assignmentFormSelector = formValueSelector('SelectAssignmentForm');
  return {
    currentComputationId: assignmentFormSelector(state, 'computationId')
  };
};

const mapDispatchToProps = (dispatch) => ({
  runActions: bindActionCreators(runActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddDropPeriodComponent);



// WEBPACK FOOTER //
// ./src/components/runs/AddDropPeriodComponent.js